module.exports = __webpack_public_path__ + "img/SL_new.26ae90f8.png";